import { useEffect, useRef } from "react";
import { computePeaks } from "@/audio/dsp";

export const Waveform = ({ buffer, color, widthFrac, offsetFrac = 0, testId }) => {
  const canvas = useRef(null);

  useEffect(() => {
    const el = canvas.current;
    if (!el) return;
    const draw = () => {
      const dpr = window.devicePixelRatio || 1;
      const w = el.clientWidth;
      const h = el.clientHeight;
      el.width = w * dpr;
      el.height = h * dpr;
      const g = el.getContext("2d");
      g.scale(dpr, dpr);
      g.clearRect(0, 0, w, h);
      if (!buffer) return;
      const bars = Math.max(1, Math.floor((w * widthFrac) / 3));
      const peaks = computePeaks(buffer, bars);
      g.fillStyle = color;
      g.shadowColor = color;
      g.shadowBlur = 6;
      const x0 = w * offsetFrac;
      peaks.forEach((p, i) => {
        const bh = Math.max(1, p * (h - 6));
        g.fillRect(x0 + i * 3, (h - bh) / 2, 2, bh);
      });
    };
    draw();
    const ro = new ResizeObserver(draw);
    ro.observe(el);
    return () => ro.disconnect();
  }, [buffer, color, widthFrac, offsetFrac]);

  return <canvas ref={canvas} data-testid={testId} className="absolute inset-0 w-full h-full" />;
};
